import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import useCopyToClipboard from "../../common/useCopyToclipboard";
import { useMutation, useQuery } from "react-query";
import {
  destroyApplication,
  loadApplications,
} from "../../../queries/consumer/application";
import { removeItem } from "../../../redux/reducers/helpers";
import ReactPaginate from "react-paginate";

const ApplicationsPage = ({ queryClient }) => {
  const [isCopied, handleCopy] = useCopyToClipboard(3000);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const {
    isLoading,
    isError,
    data: applications,
    isPreviousData,
  } = useQuery(
    ["applications", page],
    async () =>
      await loadApplications(page).then((data) => {
        setTotalPages(data?.meta?.total_pages || 0);
        setPage(data?.meta?.page || 1);
        return data.results;
      }),
    {
      keepPreviousData: true,
    }
  );

  const deleteApplication = useMutation(async (application) => {
    if (confirm(`Are you sure that you want to delete ?`)) {
      return destroyApplication(application.id).then((data) => {
        queryClient.setQueryData(
          ["applications", page],
          removeItem(applications, data)
        );
      });
    }
  });

  const handlePageClick = (e) => {
    if (!isPreviousData) {
      setPage(e.selected + 1);
    }
  };

  return (
    <div className="container">
      <div className="d-flex align-items-center mb-5">
        <h3 className="m-0">Apps</h3>
        <Link
          to="/applications/new"
          className="btn btn-sm btn-main px-md-4 ml-auto"
        >
          Create app
        </Link>
      </div>

      <table className="table-list">
        <thead>
          <tr>
            <th>APP NAME / SUBSCRIBED APIs</th>
            <th>CLIENT ID</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {applications && !isLoading && !isError && (
            <>
              {applications.map((application) => (
                <tr key={application.id}>
                  <td>
                    <h5 className="mb-1">
                      <Link to={`/applications/${application.id}`}>
                        {application.name}
                      </Link>
                    </h5>
                    <code className="text-body">
                      {application.apiProducts.join(", ")}
                    </code>
                  </td>
                  <td data-title="CLIENT ID">
                    <span className="code-wrapper">
                      <code>{application.clientId}</code>
                      <a>
                        <i
                          className="cp-icon"
                          onClick={() => handleCopy(application.clientId)}
                        />
                      </a>
                    </span>
                  </td>
                  <td className="table-actions">
                    <Link
                      to={`applications/${application.id}`}
                      className="btn-transparent ml-n2 ml-md-0"
                    >
                      View
                    </Link>
                    <a
                      className="btn-transparent"
                      onClick={() =>
                        deleteApplication.mutate({
                          id: application.id,
                        })
                      }
                    >
                      Delete
                    </a>
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>
      {totalPages > 1 && !isLoading && (
        <ReactPaginate
          onPageChange={(e) => handlePageClick(e)}
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={totalPages}
          pageRangeDisplayed={totalPages}
          marginPagesDisplayed={2}
          containerClassName={"pagination mt-45"}
          activeClassName={"active"}
          activeLinkClassName={"current"}
        />
      )}
    </div>
  );
};

ApplicationsPage.propTypes = {
  queryClient: PropTypes.object.isRequired,
};

export default ApplicationsPage;
